
import axios from "axios"
import api from "../api"
import { formatDateForAPI } from "../common/utils"
import { baseUrl, config, requestID } from "../common/utils"

// Interfaces
export interface Document {
  name: string
  url: string
  type: string
  size: number
}

export interface Employee {
  id: string
  user_id: string
  uname: string
  firstName: string
  lastName: string
  department?: string
  position?: string
  userName: string
  email: string
  phone: string
  onboardingStatus?: "not_started" | "completed" | "in_progress"
  completionPercentage?: number
  documentsStatus?: "not_started" | "completed" | "in_progress"
  orientationStatus?: "not_started" | "completed" | "in_progress"
  coursesStatus?: "not_started" | "completed" | "in_progress"
  profileStatus?: "not_started" | "completed" | "in_progress"
  certificateStatus?: "not_started" | "completed" | "in_progress"
  startDate?: string
  onboarding_document_id?: string
  documents?: Document[]
  orientation?: Document[]
  courses?: Document[]
  profile?: Document[]
  certificate?: Document[]
}

 

export interface LeaveApplication {
  id: string
  employee_id: string
  employeeName: string
  leave_type: string
  start_date: string
  end_date: string
  reliefPersonName: string
  contactInfo: string
  location: string
  department: string
  reason: string
  status: "pending" | "approved" | "rejected"
  documents?: Document[]
  created_at: string
  days_requested: number
  daysRemaining: number
  leave_id: string
  supporting_documents?: Document[]
}

// Get all employees for relief person selection
export const getAllEmployees = async () => {
  // console.log("Sending payload:", { requestID: requestID() });
  try {
    const response = await api.post(`/businesss/getAllStaffs_haas`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
      config,
    })
    console.log("API Response:", response)

    // Check if the API call was successful
    // return response?.data?.data?.map((user: any) => ({
    //   id: user.id,
    //   user_id: user.user_id,
    //   uname: user.uname,
    //   department: user.department,
    //   position: user.position,
    //   userName: user.userName,
    //   email: user.email,
    //   phone: user.phone,
    //   firstName: user.firstName,
    //   lastName: user.lastName,
    // }))
    return response.data.data
    

     // Parse the API response based on the actual structure
    //  if (response.data && Array.isArray(response.data)) {
    //   return response.data.map((user: any) => ({
    //     id: user.id,
    //     user_id: user.user_id,
    //     uname: user.uname,
    //     userName: user.userName,
    //     email: user.email,
    //     phone: user.phone,
    //     amount: user.amount,
    //     savingAmount: user.savingAmount,
    //   }))
    // }

    // return []
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

export const getEmployeeLeave = async (): Promise<LeaveApplication[]> => {
  
  try {
//     console.log("Sending payload:", { requestID: requestID() });
// console.log("Headers:", config);

    const response = await axios.post(baseUrl() + "Leaves/getUserLeaves", 
      { requestID: requestID() },
      config,
    )
    console.log("API Response:", response)

    // Check if the API call was successful
    return response.data.data.map((user: any) => ({
      id: user.id,
      created_at: user.created_at,
      days_requested: user.days_requested,
      department: user.department,
      status: user.status,
      userName: user.userName,
      email: user.email,
      // phone: user.phone,
      end_date: user.end_date,
      start_date: user.start_date,
      leave_type: user.leave_type,
      leave_id: user.leave_id,
      employeeName: user.employeeName,
      employee_id: user.employee_id,
    }))

     // Parse the API response based on the actual structure
    //  if (response.data && Array.isArray(response.data)) {
    //   return response.data.map((user: any) => ({
    //     id: user.id,
    //     user_id: user.user_id,
    //     uname: user.uname,
    //     userName: user.userName,
    //     email: user.email,
    //     phone: user.phone,
    //     amount: user.amount,
    //     savingAmount: user.savingAmount,
    //   }))
    // }

    // return []
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}
export const getEmployerLeave = async (): Promise<LeaveApplication[]> => {
  
  try {
//     console.log("Sending payload:", { requestID: requestID() });
// console.log("Headers:", config);

    const response = await axios.post(baseUrl() + "Leaves/getAllLeaves", 
      { requestID: requestID() },
      config,
    )
    console.log("API Response:", response)

    // Check if the API call was successful
    return response.data.data.map((user: any) => ({
      id: user.id,
      created_at: user.created_at,
      days_requested: user.days_requested,
      department: user.department,
      status: user.status,
      userName: user.userName,
      email: user.email,
      // phone: user.phone,
      end_date: user.end_date,
      start_date: user.start_date,
      leave_type: user.leave_type,
      leave_id: user.leave_id,
      employeeName: user.employeeName,
      employee_id: user.employee_id,
    }))

     // Parse the API response based on the actual structure
    //  if (response.data && Array.isArray(response.data)) {
    //   return response.data.map((user: any) => ({
    //     id: user.id,
    //     user_id: user.user_id,
    //     uname: user.uname,
    //     userName: user.userName,
    //     email: user.email,
    //     phone: user.phone,
    //     amount: user.amount,
    //     savingAmount: user.savingAmount,
    //   }))
    // }

    // return []
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

// Get a specific leave application
export const getLeaveApplication = async (id: string): Promise<LeaveApplication | null> => {
  try {
    console.log("sendind id:", id)
  
const response = await axios.post(baseUrl() + `Leaves/getLeavesDetails`,
   
  {
    leaves_id: id,
    requestID: requestID()
  },
config,
);
    console.log("API Response:", response.data.data)
    return response.data.data;

    // Mock data for now
    // return {
    //   id: "1",
    //   employeeId: "EMP001",
    //   employeeName: "John Doe",
    //   leaveType: "Annual Leave",
    //   startDate: "2025-06-10",
    //   endDate: "2025-06-20",
    //   reliefPerson: "Jane Smith",
    //   contactInfo: "+1234567890",
    //   location: "New York",
    //   department: "Engineering",
    //   reason: "Family vacation",
    //   status: "pending",
    //   documents: [
    //     {
    //       name: "vacation_plan.pdf",
    //       url: "/documents/vacation_plan.pdf",
    //       type: "application/pdf",
    //       size: 1024000,
    //     },
    //   ],
    //   createdAt: "2025-05-01",
    //   daysRequested: 10,
    //   daysRemaining: 18,
    // }
  } catch (error) {
    console.error("Error fetching leave application:", error)
    throw new Error("Failed to fetch leave application")
  }
}

// Create a new leave application
export const createLeaveApplication = async (formData: FormData): Promise<{ success: boolean; id: string }> => {

   try {
    // Format dates for API
    if (formData.has("startDate")) {
      const startDate = new Date(formData.get("startDate") as string)
      formData.set("startDate", formatDateForAPI(startDate))
    }

    if (formData.has("endDate")) {
      const endDate = new Date(formData.get("endDate") as string)
      formData.set("endDate", formatDateForAPI(endDate))
    }

    // Make sure the selected relief person's ID and name are included
    if (formData.has("reliefPersonId") && formData.has("reliefPersonName")) {
      // These are already set in the form, so we don't need to modify them
    } else {
      console.error("Relief person ID or name missing from form data")
    }

    // Send the form data to the API
    // const response = await api.post("Leaves/applyLeave", {
    //     formData,
        
    //   })

    const response = await axios.post(`${baseUrl()}leaves/applyleave1`, formData, config)
    for (const key of formData.keys()) {
      console.log(key, formData.get(key))
    }

    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value)
    }

    // Check if the API call was successful
    if (response.data && response.data.success) {
      return {
        success: true,
        id: response.data.id || response.data.leaveId || "1", // Fallback ID if not provided
      }
    } else {
      throw new Error(response.data.message || "xxFailed to submit leave application")
      console.error("API Error:", response.data.message)
    }
  } catch (error: any) {
    console.error("Error creating leave application:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to submit leave application")
  }
}

// Update leave status (approve/reject)
export const updateLeaveStatus = async ({
  leaveId,
  status,
  comments,
  employeeId,
}: {
  leaveId: string
  status: "approved" | "rejected"
  comments?: string
  employeeId?: string
}): Promise<{ success: boolean }> => {
  try {
    
    const response = await axios.post(baseUrl() + 'Leaves/updateLeaveStatus', {
      leaves_id: leaveId,
      status: status,
      comments: comments,
      employee_id: employeeId,
      requestID: requestID()
    },
    config,
    );
    console.log("API Response:", response)
    return response.data;
    
    // return { success: response.data.success };

    // Mock success for now
    // return { success: true }
  } catch (error) {
    console.error("Error updating leave status:", error)
    throw new Error("Failed to update leave status")
  }
}

// Get all leave applications for the current user
export const getUserLeaveApplications = async (): Promise<LeaveApplication[]> => {
  try {
    // This is a mock implementation - replace with actual API call when endpoint is available
    const response = await api.get('Leaves/getUserLeaves');
    return response.data;

    // Mock data for now
    // return [
    //   {
    //     id: "1",
    //     employeeId: "EMP001",
    //     employeeName: "John Doe",
    //     leaveType: "Annual Leave",
    //     startDate: "2025-06-10",
    //     endDate: "2025-06-20",
    //     reliefPerson: "Jane Smith",
    //     contactInfo: "+1234567890",
    //     location: "New York",
    //     department: "Engineering",
    //     reason: "Family vacation",
    //     status: "pending",
    //     documents: [],
    //     createdAt: "2025-05-01",
    //     daysRequested: 10,
    //     daysRemaining: 18,
    //   },
    //   {
    //     id: "2",
    //     employeeId: "EMP001",
    //     employeeName: "John Doe",
    //     leaveType: "Sick Leave",
    //     startDate: "2025-05-15",
    //     endDate: "2025-05-16",
    //     reliefPerson: "Robert Johnson",
    //     contactInfo: "+1234567890",
    //     location: "New York",
    //     department: "Engineering",
    //     reason: "Doctor's appointment",
    //     status: "approved",
    //     documents: [],
    //     createdAt: "2025-05-02",
    //     daysRequested: 2,
    //     daysRemaining: 18,
    //   },
    // ]
  } catch (error) {
    console.error("Error fetching user leave applications:", error)
    throw new Error("Failed to fetch leave applications")
  }
}
